
const Testimonials = () => {
  const testimonials = [
    {
      name: "Carla",
      location: "Brasil",
      rating: 5,
      text: "Lugar maravilhoso! A casa é muito aconchegante e bem equipada. O rio ao lado é um espetáculo à parte. As crianças adoraram a quadra de tênis. Experiência incrível!",
      date: "Dezembro 2024"
    },
    {
      name: "Ricardo",
      location: "São Paulo",
      rating: 5,
      text: "Propriedade excepcional! A vista para as montanhas é deslumbrante e a tranquilidade do local é revigorante. A área gourmet com churrasqueira é perfeita para reunir a família.",
      date: "Novembro 2024"
    },
    {
      name: "Fernanda",
      location: "Rio de Janeiro",
      rating: 5,
      text: "Casa linda e muito bem cuidada! Todos os quartos têm sacada com vistas incríveis. A fogueira à noite foi mágica. Julia é uma anfitriã muito atenciosa. Recomendo!",
      date: "Outubro 2024"
    },
    {
      name: "Paulo",
      location: "Belo Horizonte",
      rating: 5,
      text: "Lugar perfeito para descansar e se conectar com a natureza. A casa é espaçosa e confortável. As trilhas na propriedade são um diferencial. Voltaremos com certeza!",
      date: "Setembro 2024"
    },
    {
      name: "Marina",
      location: "Curitiba",
      rating: 4,
      text: "Experiência maravilhosa! A localização na Estrada Bonita é privilegiada, cercada de muito verde. O ar condicionado em todos os ambientes foi um alívio. Lugar especial!",
      date: "Agosto 2024"
    },
    {
      name: "André",
      location: "Florianópolis",
      rating: 5,
      text: "Casa incrível para criar memórias com quem você ama! O lago e o rio proporcionam momentos únicos. A quadra de tênis iluminada é sensacional. Experiência inesquecível!",
      date: "Julho 2024"
    }
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-stone-800 mb-6">
            O que nossos <span className="text-olive-600">hóspedes dizem</span>
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Depoimentos reais de hóspedes que se hospedaram em nossa chácara através do Airbnb.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-stone-600 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              
              <div className="border-t border-stone-200 pt-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium text-stone-800">{testimonial.name}</h4>
                    <p className="text-sm text-stone-500">{testimonial.location}</p>
                  </div>
                  <div className="text-xs text-stone-400">
                    {testimonial.date}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-md">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
              ))}
            </div>
            <span className="text-stone-800 font-medium">4,71</span>
            <span className="text-stone-600">• 7 avaliações no Airbnb</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
